import type { FormikContextType } from 'formik';
import { useFormik } from 'formik';
import _ from 'lodash';
import { useEffect } from 'react';
import * as Yup from 'yup';
import { Alert, Store } from '../../store';

interface Values {
  email: string;
  password: string;
  remember: boolean;
}

interface Form {
  formik: FormikContextType<Values>;
  loading: boolean;
  alert: Alert;
}

const validationSchema = Yup.object({
  email: Yup.string()
    .trim()
    .required('Please enter a valid email address.')
    .email('Please enter a valid email address.'),
  password: Yup.string().trim().required('A valid password is required.')
});

export const useForm = (): Form => {

  const [authenticate, { loading, error, tokens }] = Store.User.useAuthenticate();
  const { token, webplayerToken } = tokens ?? {};
  const alert = Alert.useAlert(error);

  const formik = useFormik<Values>({
    initialValues: { email: '', password: '', remember: true },

    validationSchema,
    validateOnMount: true,

    validate(): void {
      alert.hide();
    },

    onSubmit(data: Values): void {
      alert.hide();

      if (!loading) {
        // Execute the mutation
        void authenticate(_.omit(data, 'remember'));
      }
    }
  });

  useEffect(() => {
    if (token && webplayerToken) {
      Store.User.login({ token, webplayerToken }, { persistent: formik.values.remember });
    }
  }, [formik.values.remember, token, webplayerToken]);

  return {
    formik,
    loading,
    alert
  };
};
